import { FormItemTypes } from "../../../../builderPackage/components/dynamicFormBuilder/formBuilder/dynamicFormBuilder.entity";
export var failureReporteElement = [{
        type: FormItemTypes.CardComponent,
        name: '',
        columnSize: 12,
        containerProps: {
            m: 0,
            mb: 1.5,
            spacing: 0
        },
        sx: {
            padding: '12px'
        },
        contentProps: {
            spacing: 0,
            p: 0,
            rowGap: '12px'
        },
        elements: [{
                type: FormItemTypes.Typography,
                name: '',
                value: 'Gujarat',
                columnSize: 12,
                fontWeight: 'medium'
            }, {
                type: FormItemTypes.ContainerItem,
                name: '',
                columnSize: 12,
                spacing: 0,
                p: 1,
                rowGap: '4px',
                sx: {
                    bgcolor: 'secondary.50',
                    borderRadius: '8px'
                },
                elements: [{
                        type: FormItemTypes.Typography,
                        name: 'Intensity:',
                        label: 'Intensity :',
                        value: null,
                        containerProps: {
                            display: 'inline-flex',
                            justifyContent: 'space-between',
                            alignItems: 'baseline',
                            gap: 1,
                            spacing: 0
                        },
                        labelTypographyProps: {
                            mb: 0,
                            noWrap: true,
                            fontWeight: 'medium',
                            fontSize: 'sm'
                        },
                        fontWeight: 'medium',
                        fontSize: 'sm',
                        columnSize: 12
                    }, {
                        type: FormItemTypes.Typography,
                        name: 'No of FR’s:',
                        label: 'No of FR’s:',
                        value: null,
                        containerProps: {
                            display: 'inline-flex',
                            justifyContent: 'space-between',
                            alignItems: 'baseline',
                            gap: 1,
                            spacing: 0
                        },
                        labelTypographyProps: {
                            mb: 0,
                            noWrap: true,
                            fontWeight: 'medium',
                            fontSize: 'sm'
                        },
                        fontWeight: 'medium',
                        fontSize: 'sm',
                        columnSize: 12
                    }]
            }]
    }];
